/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TaskTickComplete from './task-tick-complete.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TaskTickComplete {...validProps} />;
}
SvgComponent.iconName = 'task-tick-complete';

export const TaskTickCompleteIcon = svgIconWrapper(SvgComponent);
